// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__j_C44","link":"styles_link__2en0a"};